export default {"src":"/_next/static/media/roundarrow.98ee8e3c.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};